import { useCompanyStock } from './../../hooks/useCompanyStock';
import { getPriceTypeText } from './../../utils';
import { CountryFlag } from './CountryFlag';
import { CompanyLogo } from '@/components/CompanyLogo';
import type { ISO2 } from '@/constants/countries';

export const Header = () => {
  const company = useCompanyStock();

  return (
    <header>
      <div className="grid grid-cols-[auto_minmax(0,1fr)] items-center gap-3.5 pb-4 lg:pt-4">
        <div className="self-start shadow-sm [&_img]:opacity-100">
          <CompanyLogo
            website={company.url}
            tickerSymbol={company.tickerSymbol}
            sizeLg={52}
            hasLogo={company.hasLogo}
          />
        </div>
        <div className="flex flex-col gap-1">
          <h1 className="m-0 text-base font-medium leading-9 [text-box-trim:trim-both]">
            {company.shortName}{' '}
            {getPriceTypeText(company.exchangeCountryISO as ISO2).priceLabel}
          </h1>
          <div className="flex flex-wrap gap-1 align-middle text-xs text-soft [text-box-trim:trim-both]">
            <span
              aria-hidden="true"
              className="inline-flex aspect-[16/12] w-4 shrink-0"
            >
              <CountryFlag countryISO={company.countryISO as ISO2} />
            </span>
            <span className="sr-only">Symbol: </span>
            {company.uniqueSymbol}
            <span className="font-bold text-softer" aria-hidden="true">
              &nbsp;&middot;&nbsp;
            </span>
            <span className="sr-only">Market Cap: </span>
            {company.marketCap}
            <span className="font-bold text-softer" aria-hidden="true">
              &nbsp;&middot;&nbsp;
            </span>
            <span className="sr-only">Category: </span>
            {company.primaryIndustry.name}
          </div>
        </div>
      </div>
    </header>
  );
};
